// Styles for OneUpHighlight go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledOneUpHighlight = styled.div`
  .luxury-OneUpHighlight {
    padding: ${toRem(64)} 0;
    align-items: center;
    width: 100%;

    p {
      margin-bottom: 0;
    }
  }

  .luxury-OneUpHighlight-secondary-image-wrap {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-bottom: ${toRem(64)};

    @media ${baseVariables.mediaQuery.xl} {
      margin-bottom: ${toRem(64)};
    }
  }

  /* Primary left (mobile/tablet): secondary stacks after copy; xl restores secondary above copy */
  .luxury-OneUpHighlight-secondary-image-wrap--below-text {
    margin-bottom: 0;
    margin-top: ${toRem(32)};

    @media ${baseVariables.mediaQuery.xl} {
      margin-top: 0;
      margin-bottom: ${toRem(64)};
    }
  }

  /* Figma: ~225 mobile, ~525 tablet, 267 desktop (xl+) */
  .luxury-OneUpHighlight-secondary-image-inner {
    width: 100%;
    max-width: ${toRem(225)};
    overflow: hidden;
    aspect-ratio: 2/3;

    @media ${baseVariables.mediaQuery.md} {
      max-width: ${toRem(525)};
    }

    @media ${baseVariables.mediaQuery.xl} {
      max-width: ${toRem(267)};
    }

    picture {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .luxury-OneUpHighlight-secondary-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .luxury-OneUpHighlight-image,
  .luxury-OneUpHighlight-video {
    width: 100%;
    aspect-ratio: 9/16;
  }
  .no-thumbnail {
    .video-image-container {
      min-height: ${toRem(847)};
      @media ${baseVariables.mediaQuery.md} {
        min-height: ${toRem(1046)};
      }
      @media ${baseVariables.mediaQuery.lg} {
        min-height: ${toRem(819)};
      }
    }
  }
  .luxury-OneUpHighlight-video {
    .video-image-container {
      img {
        width: 100%;
      }

      svg {
        width: ${toRem(48)};
        height: ${toRem(48)};
      }
    }
  }

  .luxury-OneUpHighlight-video--in-placeholder {
    position: relative;
    /* visible so captions / audio-description pop-up menus are not clipped (child video still fills slot) */
    overflow: hidden;
  }

  .luxury-OneUpHighlight-video--in-placeholder .luxury-OneUpHighlight-phoenix-inline-video {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .luxury-OneUpHighlight-video--in-placeholder .luxury-OneUpHighlight-phoenix-cover {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    pointer-events: none;
    transition: opacity 0.2s ease;

    .luxury-OneUpHighlight-phoenix-cover-image,
    picture,
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  .luxury-OneUpHighlight-video--in-placeholder
    .luxury-OneUpHighlight-phoenix-inline-video:has(.video-js.vjs-has-started)
    .luxury-OneUpHighlight-phoenix-cover {
    opacity: 0;
  }

  /*
   * Phoenix inline player: match mi-ui-library Video (Video.styles.tsx StyledVideoModal) for Video.js chrome.
   * Control bar uses position absolute so it stays inside the slot (modal uses fixed on small viewports).
   */
  .luxury-OneUpHighlight-video--in-placeholder .luxury-OneUpHighlight-video-player {
    position: relative;
    z-index: 2;
    width: 100%;
    height: 100%;

    [class^='vjs-']::before {
      font-family: 'VideoJS';
    }

    .brightcove-react-player-loader {
      width: 100%;
      height: 100%;
      display: block;
    }

    video-js,
    .video-js {
      width: 100% !important;
      height: 100% !important;
      min-height: 100% !important;
      padding-top: 0 !important;
      margin: 0 !important;
      background: transparent !important;
      /* allow captions / audio-description menus to extend above the control bar */
      overflow: hidden;

      [class*='icon-']::before {
        font-family: 'VideoJS';
        color: ${baseVariables.color.base20};
      }
    }

    .brightcove-react-player-loader .video-js .vjs-big-play-button {
      z-index: 3;
      background-color: rgba(0, 0, 0, 0.45);
      width: ${toRem(48)};
      height: ${toRem(48)};
      line-height: ${toRem(48)};
      border-radius: 50%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin: 0;

      span::before {
        color: ${baseVariables.color.base20};
        font-size: ${toRem(30)};
        line-height: ${toRem(48)};
      }
    }

    .video-js:not(.vjs-has-started) .vjs-tech {
      opacity: 0;
    }

    .vjs-poster {
      display: none !important;
    }

    .vjs-title-bar,
    .vjs-dock-text {
      display: none !important;
    }

    .vjs-control-bar {
      position: absolute !important;
      width: 100% !important;
      left: 0;
      right: 0;
      bottom: 0;
      color: ${baseVariables.color.base20};
      /* keep menus from being clipped by narrow portrait slot */
      overflow: visible;

      /* do not set width on progress (see HeroBannerVideo); keep icon buttons from flex-shrinking away */
      .vjs-control:not(.vjs-progress-control) {
        width: 2.5em;
        flex-shrink: 0;
      }

      /* Brightcove skin often hides these; match HeroBannerVideo.styles.tsx */
      .vjs-subs-caps-button,
      .vjs-audio-button,
      .vjs-descriptions-button {
        display: block !important;
      }

      .vjs-progress-control {
        height: ${toRem(4.19)};
        top: 0;

        .vjs-play-progress {
          background: ${baseVariables.color.base20};
        }
      }

      .vjs-volume-level {
        background: ${baseVariables.color.base20};
      }

      .vjs-menu .vjs-menu-item.vjs-selected {
        background: ${baseVariables.color.base20};

        .vjs-menu-item-text {
          color: ${baseVariables.color.base10};
        }
      }
    }

    .vjs-subs-caps-button .vjs-menu .vjs-menu-content .vjs-menu-item .vjs-subtitles-menu-item,
    .vjs-menu-button-popup .vjs-menu .vjs-menu-item.vjs-selected,
    .vjs-subs-caps-button .vjs-menu .vjs-menu-content .vjs-menu-item .vjs-subtitles-menu-item:hover,
    .vjs-menu-button-popup .vjs-menu .vjs-menu-item.vjs-selected:hover {
      background-color: ${baseVariables.color.base20};
      color: ${baseVariables.color.base10};
    }

    .vjs-tech {
      position: absolute !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      bottom: 0 !important;
      width: 100% !important;
      height: 100% !important;
      object-fit: cover;
    }

    video {
      width: 100% !important;
      height: 100% !important;
      object-fit: cover;
    }
  }

  .video-modal-container {
    aspect-ratio: 9/16 !important;
  }

  .text-block {
    @media screen and (min-width: 768px) and (max-width: 1024px) {
      margin-top: ${toRem(72)} !important;
      padding-top: ${toRem(8)} !important;
    }
  }
`;
